import { render, staticRenderFns } from "./feeContent.vue?vue&type=template&id=12823e84&scoped=true&"
import script from "./feeContent.vue?vue&type=script&lang=js&"
export * from "./feeContent.vue?vue&type=script&lang=js&"
import style0 from "./feeContent.vue?vue&type=style&index=0&id=12823e84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12823e84",
  null
  
)

export default component.exports